import { useQuery } from "@tanstack/react-query";
import api from "@/lib/api";
import { PageHeader } from "@/components/common";
import { FinalDownloads } from "@/components/roster/FinalRoster";
import { formatDateTimeIST } from "@/lib/format";
import { Card } from "@/components/ui/card";

const MONTHS = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

export default function FinalRosters() {
  const { data = [], isLoading } = useQuery({ queryKey: ["final-all"], staleTime: 0, refetchOnMount: "always",
    queryFn: async () => (await api.get("/roster/final/all")).data });
  return (
    <div>
      <PageHeader title="Final rosters" description="Combined monthly rosters sent by organisations, ready to download or import into Zoho." />
      <Card className="divide-y divide-slate-100" data-testid="final-rosters-list">
        {data.map((f) => (
          <div key={f.id} className="flex flex-wrap items-center justify-between gap-3 px-5 py-4" data-testid={`final-row-${f.id}`}>
            <div>
              <p className="text-base font-semibold text-slate-900">{f.org_name} · {MONTHS[f.month - 1]} {f.year} <span className="text-sm font-normal text-slate-600">v{f.version}</span></p>
              <p className="text-sm text-slate-600">{f.employee_count} employees · {f.location_count} location(s) · {f.roster_count} roster(s) · sent by {f.sent_by} on {formatDateTimeIST(f.sent_at)}</p>
            </div>
            <FinalDownloads f={f} />
          </div>
        ))}
        {!isLoading && !data.length && <p className="p-6 text-sm text-slate-500" data-testid="final-rosters-empty">No final rosters have been sent yet.</p>}
      </Card>
    </div>
  );
}
